/**
 * Response Pair Tabs Component
 * Renders the tabs for a response pair
 */

import React from 'react';
import { TabItem } from '@/constants/chatScreenData';
import { Tab } from '@/design-system';
import { spacing } from '@/design-system/utils';

export interface ResponsePairTabsProps {
  tabs: TabItem[];
  activeTab: string;
  conversationId: string;
  isLastPair: boolean;
  onTabChange: (
    tabId: string,
    conversationId: string,
    isLastPair: boolean
  ) => void;
}

export const ResponsePairTabs: React.FC<ResponsePairTabsProps> = ({
  tabs,
  activeTab,
  conversationId,
  isLastPair,
  onTabChange,
}) => {
  return (
    <div
      className='overflow-x-auto scrollbar-hide'
      style={{
        display: 'flex',
        gap: spacing[3],
        width: '100%',
        paddingBottom: '4px',
      }}
    >
      {tabs.map(tab => (
        <Tab
          key={tab.id}
          label={tab.label}
          isActive={activeTab === tab.id}
          onClick={e => {
            // Prevent any event propagation that might trigger other handlers
            e?.stopPropagation?.();
            e?.preventDefault?.();
            // Update the specific conversation's tab
            onTabChange(tab.id, conversationId, isLastPair);
          }}
        />
      ))}
    </div>
  );
};
